/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Vc_Facts_VersionInputs */

const en_vc_facts_version = /** @type {(inputs: Vc_Facts_VersionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Latest version`)
};

const zh_vc_facts_version = /** @type {(inputs: Vc_Facts_VersionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`最新版本`)
};

/**
* | output |
* | --- |
* | "Latest version" |
*
* @param {Vc_Facts_VersionInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const vc_facts_version = /** @type {((inputs?: Vc_Facts_VersionInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vc_Facts_VersionInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_vc_facts_version(inputs)
	return zh_vc_facts_version(inputs)
});
export { vc_facts_version as "vc.facts.version" }